import React from 'react';
import { LandingComponent } from 'app/types';
import Text from 'common/components/Text/Text';

import { Button } from 'react-bootstrap';
import { useMediaQuery } from 'react-responsive';
import styles from '../LandingForm.module.scss';

interface PreviewComponentProps {
  landing_cmp: LandingComponent;
}

const BannerPreview = ({ landing_cmp }: PreviewComponentProps): React.ReactElement => {
  const isTablet = useMediaQuery({ maxWidth: 900 });

  const buttonStyle = (style?: string) => {
    if (style === 'secondary') {
      return styles.secondaryButton;
    } else if (style === 'light') {
      return styles.lightButton;
    } else {
      return styles.primaryButton;
    }
  };
  return (
    <div
      id={landing_cmp.html_id}
      key={landing_cmp.id}
      className={landing_cmp.class_name}
      style={{
        width: landing_cmp.size !== 'sm' && landing_cmp.size !== 'md' ? landing_cmp.size : 'auto',
        padding: isTablet ? '20px' : landing_cmp.size === 'sm' ? '0 12rem' : '0 4vw',
        margin: landing_cmp.gap,
        background: !(landing_cmp.background instanceof File) ? landing_cmp.background : 'auto',
        backgroundImage: `url(${landing_cmp.background_image})`,
        backgroundSize: landing_cmp.background_size,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: !isTablet ? '360px' : 'auto',
      }}
    >
      <div
        className="bannerContent"
        style={{
          display: 'flex',
          flexDirection: isTablet ? 'column' : 'row',
          justifyContent: 'space-between',
          alignItems: 'center',
          background: 'white',
          borderRadius: '10px',
          width: '80%',
          height: '70%',
          padding: !isTablet ? '0 40px' : '20px',
        }}
      >
        {landing_cmp.image_file && typeof landing_cmp.image_file === 'string' ? (
          <img
            src={landing_cmp.image_file}
            height={!isTablet ? '160px' : '80px'}
            width={!isTablet ? '160px' : '80px'}
            style={{ borderRadius: '80px' }}
          ></img>
        ) : (
          <div style={{ height: '160px', width: '73px', borderRadius: '50%' }}>
            <i className="bi bi-person-circle"></i>
          </div>
        )}
        <div
          className="infoSection"
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '24px',
            justifyContent: 'center',
            alignItems: 'center',
            maxWidth: '60%',
          }}
        >
          {landing_cmp.config.title && (
            <Text
              inlineStyle={{ color: '#193676', textAlign: isTablet ? 'center' : 'auto' }}
              size={isTablet ? 20 : 30}
              weight={700}
            >
              {landing_cmp.config.title}
            </Text>
          )}
          {landing_cmp.config.banner_text && (
            <Text
              inlineStyle={{
                color: '#727D9B',
                textAlign: isTablet ? 'center' : 'auto',
                marginBottom: isTablet ? '20px' : 'auto',
              }}
              size={isTablet ? 14 : 16}
              weight={400}
            >
              {landing_cmp.config.banner_text}
            </Text>
          )}
        </div>
        {landing_cmp.landing_component_buttons[0] && (
          <Button
            key={landing_cmp.id}
            href={landing_cmp.landing_component_buttons[0].link}
            className={buttonStyle(landing_cmp.landing_component_buttons[0].style)}
          >
            {landing_cmp.landing_component_buttons[0].text}
          </Button>
        )}
      </div>
    </div>
  );
};

export default BannerPreview;
